import { Card, Dialog, Stack } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  FunctionField,
  List,
  TextField,
  useTranslate,
  DeleteButton,
  EditButton,
  useNotify,
  useRedirect,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import CreateTask from './mutations/Create';
import EditTask from './mutations/Edit';
import JsonDetailViewer from '../../../components/JsonDetailViewer';
// 导入数据提供者初始化
import './init';

const View = () => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const [popup, setPopup] = useState<ReactElement>();
  const notify = useNotify();
  return (
    <PermissionGuard resource="activity-tier-benefit" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.activityTierBenefits')}
          links={[
            { name: translate('resource.activity') },
            { name: translate('resource.activityTierBenefits') },
          ]}
          action={
            <PermissionGuard resource="activity-tier-benefit" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateTask onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List resource="activity-tier-benefit" actions={false} empty={false} exporter={false}>
            <Datagrid
              rowClick={false}
              bulkActionButtons={
                <PermissionGuard resource="activity-tier-benefit" action="delete" fallback={<></>}>
                  <BulkDeleteButton
                    mutationMode="pessimistic"
                    mutationOptions={{
                      onSuccess: () =>
                        notify(translate('activity.tierBenefits.updatedSuccessfully'), { type: 'success' }),
                    }}
                  />
                </PermissionGuard>
              }
            >
              <TextField source="id" label={translate('activity.common.id')} sortable={false} />
              <TextField source="tierName" label={translate('activity.tierBenefits.tierName')} sortable={false} />
              <TextField source="tierLevel" label={translate('activity.tierBenefits.tierLevel')} sortable={false} />
              <TextField source="minPoints" label={translate('activity.tierBenefits.minPoints')} sortable={false} />
              <TextField source="cashbackPercentage" label={translate('activity.tierBenefits.cashbackPercentage')} sortable={false} />
              <TextField source="referredIncentivePercentage" label={translate('activity.tierBenefits.referredIncentivePercentage')} sortable={false} />
              <TextField source="futureCashbackPercentage" label={translate('activity.tierBenefits.futureCashbackPercentage')} sortable={false} />
              <TextField source="netFee" label={translate('activity.tierBenefits.netFee')} sortable={false} />
              <TextField source="benefitsDescription" label={translate('activity.common.description')} sortable={false} />
              <FunctionField
                label={translate('activity.common.active')}
                render={(r: any) => (r?.isActive ? 'Yes' : 'No')}
                sortable={false}
              />
              <FunctionField
                label={translate('activity.common.detail')}
                render={(record: any) => (
                  <JsonDetailViewer data={record} maxLength={20} label={translate('activity.common.detail')} />
                )}
                sortable={false}
              />
              <FunctionField
                label={translate('activity.common.actions')}
                render={(record: any) => (
                  <Stack direction="row" spacing={2}>
                    <PermissionGuard
                      resource="activity-tier-benefit"
                      action="update"
                      fallback={<></>}
                    >
                      <EditButton
                        onClick={(e) => {
                          e.preventDefault();
                          setPopup(
                            <EditTask
                              id={record.id}
                              resource={record}
                              onClose={() => setPopup(undefined)}
                            />
                          );
                        }}
                      />
                    </PermissionGuard>
                    <PermissionGuard
                      resource="activity-tier-benefit"
                      action="delete"
                      fallback={<></>}
                    >
                      <DeleteButton
                        mutationMode="pessimistic"
                        mutationOptions={{
                          onSuccess: () => redirect('/activity/tasks'),
                        }}
                      />
                    </PermissionGuard>
                  </Stack>
                )}
              />
            </Datagrid>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
